import * as React from 'react';

import * as SwitchPrimitive from '@radix-ui/react-switch';

const Switch = React.forwardRef<
    React.ComponentRef<typeof SwitchPrimitive.Root>,
    React.ComponentPropsWithoutRef<typeof SwitchPrimitive.Root>
>(({ ...props }, ref) => (
    <SwitchPrimitive.Root
        className="data-[state=checked]:bg-primary-600 relative h-6 w-11 cursor-pointer rounded-full bg-gray-300 focus:outline-hidden disabled:cursor-default disabled:opacity-20"
        ref={ref}
        {...props}
    >
        <SwitchPrimitive.Thumb className="ml-0.5 block size-5 translate-x-0 rounded-full bg-white transition-transform duration-200 data-[state=checked]:translate-x-5" />
    </SwitchPrimitive.Root>
));
Switch.displayName = 'Switch';

export { Switch };
